export default __webpack_public_path__ + "img/innovation.1.asset.77a03a7d.png";